import produce from 'immer';

import {
  ERROR_SET,
  CARD_ERROR,
  AUTH_ERROR,
  ORDER_ERROR,
  ERROR_CLEAR,
  USERS_ERROR,
  ORDERS_ERROR,
  COUNCIL_ERROR,
  COUNCILS_ERROR,
  CONNECT_ERROR,
  OAUTH_ERROR,
  USERS_INVITE_ERROR,
  ERROR_INPUT_CLEAR,
  REGISTRATION_ERROR,
  ADDRESS_SEARCH_ERROR
} from 'constants/actions';

export const INITIAL_STATE = {
  code: '',
  title: '',
  message: '',
  inputErrors: {},

  critical: false
};

export const error = produce((draft, action) => {
  switch (action.type) {
    case ERROR_SET:
      draft.code = action.value.code || '';
      draft.message = action.value.message || '';
      draft.inputErrors = action.value.inputErrors || {};
      return draft;

    case ERROR_CLEAR:
      draft = INITIAL_STATE;
      return draft;

    case ERROR_INPUT_CLEAR:
      draft.inputErrors[action.value] = undefined;
      return draft;

    case ADDRESS_SEARCH_ERROR:
      draft.code = action.type;
      draft.message = action.value;
      return draft;

    case COUNCILS_ERROR:
      draft.message = action.value;
      draft.critical = true;
      return draft;

    case COUNCIL_ERROR:
      draft.message = action.value;
      draft.critical = true;
      return draft;

    case OAUTH_ERROR:
      draft.message = typeof action.value === 'string' 
        ? action.value 
        : action.value.message;

      draft.code = action.type;

      return draft;

    case ORDERS_ERROR:
      draft.message = action.value;
      return draft;

    case ORDER_ERROR:
      draft.message = action.value;
      return draft;

    case AUTH_ERROR:
      draft.message = action.value;
      return draft;

    case REGISTRATION_ERROR:
      draft.message = action.value;
      return draft;

    case USERS_ERROR:
      draft.message = action.value;
      return draft;

    case USERS_INVITE_ERROR:
      draft.message = action.value;
      return draft;

    case CONNECT_ERROR:
      draft.message = action.value;
      return draft;

    case CARD_ERROR:
      draft.message = typeof action.value === 'string'
        ? action.value
        : action.value.message;

      return draft;

    default:
      return draft;
  }
}, INITIAL_STATE);

export default error;
